import { OnInit } from '@angular/core';
import { Listing } from '../../../../classes/listing';
var ListingFlagsComponent = /** @class */ (function () {
    function ListingFlagsComponent() {
        // Whether we want to show the new or updated flag if required
        this.newOrUpdatedFlagType = null;
        this.isLuxury = false;
        this.showOpenHouse = false;
    }
    Object.defineProperty(ListingFlagsComponent.prototype, "listing", {
        set: function (listing) {
            // Only Supported on Residential & Luxury
            if (listing.isCommercial) {
                return;
            }
            /* For New/Updated Flags
              New Flags: listings posted in the last 7 days, shouldn't show once 7 days past listing date
              Updated Flags: Listings updated in the last 7 days, shouldn't show once 7 days past lastUpdated date
              New & Updated: listingDate takes priority, and stop showing once 7 days past the listing Date
            */
            var listingDate = listing.listingDate ? new Date(listing.listingDate) : null;
            var lastUpdated = listing.lastUpdated ? new Date(listing.lastUpdated) : null;
            var today = new Date();
            if (listingDate && this.numDaysBetween(today, listingDate) <= 7) {
                this.newOrUpdatedFlagType = 'new';
            }
            else if (lastUpdated && this.numDaysBetween(today, lastUpdated) <= 7) {
                this.newOrUpdatedFlagType = 'updated';
            }
            this.isLuxury = listing.isLuxury;
            this.showOpenHouse = listing.hasOpenHouse && !listing.isCommercial;
        },
        enumerable: true,
        configurable: true
    });
    ListingFlagsComponent.prototype.ngOnInit = function () { };
    /**
     * Returns the number of days between two date objects
     * @param d1
     * @param d2
     */
    ListingFlagsComponent.prototype.numDaysBetween = function (d1, d2) {
        var diff = Math.abs(d1.getTime() - d2.getTime());
        return diff / (1000 * 60 * 60 * 24);
    };
    ;
    return ListingFlagsComponent;
}());
export { ListingFlagsComponent };
